<template lang="pug">
  Icon.icon(name="notification-comment" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Изменен
    Link(:to="{ name: 'task-detail', params: item.info, query: { comment: item.info.commentId } }")  комментарий
    |  в задаче
    Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
    |  в проекте
    Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
</template>

<script>
export default {
  name: 'NotificationCommentUpdate',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
